import Component from '@bythepixel/component-loader';

export default class SubNav extends Component {
  static selector = '[data-comp-lazyload-iframe]';

  constructor(el) {
    super(el);
    this.iframePreviewEl = this.$container.querySelector('[data-lazyload-iframe-preview]');
    this.iframeSelector = 'data-lazyload-iframe-src';
    this.iframeWrapperEl = this.$container.querySelector('[data-lazyload-iframe-wrapper]');
    this.iframeEl = this.iframeWrapperEl.querySelector('[data-lazyload-iframe]');
    this.iframeSrc = this.iframeEl.getAttribute('data-lazyload-iframe-src');
    this.interactiveLazyLoad = this.iframeWrapperEl.getAttribute('data-interactive-lazy-load');

    if (this.interactiveLazyLoad === 'true') {
      this.initLazyLoadClickListener();
    } else {
      this.initObserverLoader();
    }
  }

  loadIFrame(element) {
    this.iframePreviewEl.style.display = 'none';
    this.iframeEl.removeAttribute(this.iframeSelector);
    element.setAttribute('src', this.iframeSrc);
    this.iframeWrapperEl.style.display = 'block';

    if (window.YT) {
      window.YT.ready(() => {
        window.YoutubePlayers.push(new window.YT.Player(element));
      });
    }
  }

  initObserverLoader() {
    const observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0.2,
    };

    const observeVideo = (entries, observer) => {
      const element = entries[0];
      if (element.isIntersecting) {
        this.loadIFrame(element.target);
        observer.unobserve(element.target);
      }
    };

    const vObserver = new IntersectionObserver(observeVideo, observerOptions);
    vObserver.observe(this.iframeEl);
  }

  initLazyLoadClickListener() {
    this.iframePreviewEl.addEventListener('click', this.clickHandler.bind(this), false);
  }

  clickHandler() {
    this.iframePreviewEl.style.display = 'none';
    this.iframeEl.removeAttribute(this.iframeSelector);
    this.iframeEl.setAttribute('src', this.iframeSrc);
    this.iframeWrapperEl.style.display = 'block';

    if (window.YT) {
      window.YT.ready(() => {
        window.YoutubePlayers.push(new window.YT.Player(this.iframeEl));
      });
    }

    this.iframePreviewEl.removeEventListener('click', this.clickHandler.bind(this), false);
  }
}
